export const QC_GATE_TYPES = ['Content', 'Actor'] as const;
export type QcGateType = (typeof QC_GATE_TYPES)[number];

/*
 Wire format of User.QcRequiredVerticals: a bare "Vertical" gates both submission types, "Vertical:Type"
 gates only that type. The editor works on the expanded set of "Vertical:Type" keys.
 */
export const gateKey = (vertical: string, type: QcGateType) => `${vertical}:${type}`;

export function parseQcGate(entries: string[]): Set<string> {
  const keys = new Set<string>();
  for (const entry of entries) {
    const type = QC_GATE_TYPES.find((t) => entry.endsWith(`:${t}`));
    if (type) {
      keys.add(entry);
    } else {
      for (const t of QC_GATE_TYPES) {
        keys.add(gateKey(entry, t));
      }
    }
  }

  return keys;
}

export function serializeQcGate(keys: ReadonlySet<string>): string[] {
  const entries: string[] = [];
  const typed: string[] = [];
  for (const key of keys) {
    const type = QC_GATE_TYPES.find((t) => key.endsWith(`:${t}`));
    const vertical = type ? key.slice(0, -(type.length + 1)) : key;
    const both = QC_GATE_TYPES.every((t) => keys.has(gateKey(vertical, t)));
    if (both) {
      if (!entries.includes(vertical)) {
        entries.push(vertical);
      }
    } else {
      typed.push(key);
    }
  }

  return [...entries, ...typed];
}
